import { httpClient } from './http-client';
import type { ApiResponse } from './api.types';

export interface CentroCostoDto {
  id: string;
  empresaId: string;
  codigo: string;
  nombre: string;
  esVisible: boolean;
  createdAt: string;
  updatedAt: string;
}

export interface CentroCostoInputDto {
  empresaId: string;
  codigo: string;
  nombre: string;
  esVisible?: boolean;
}

export const centrosCostoService = {
  getAll: (empresaId: string): Promise<ApiResponse<CentroCostoDto[]>> =>
    httpClient.get('/centros-costo', { empresaId }),

  getById: (id: string): Promise<ApiResponse<CentroCostoDto>> =>
    httpClient.get(`/centros-costo/${id}`),

  create: (data: CentroCostoInputDto): Promise<ApiResponse<CentroCostoDto>> =>
    httpClient.post('/centros-costo', data),

  update: (id: string, data: CentroCostoInputDto): Promise<ApiResponse<CentroCostoDto>> =>
    httpClient.put(`/centros-costo/${id}`, data),

  delete: (id: string): Promise<ApiResponse<void>> =>
    httpClient.delete(`/centros-costo/${id}`),
};
